import {
	Pipe,
	PipeTransform
} from '@angular/core';

@Pipe( { name: 'lineBreakHtmlConverter' } )
export class LineBreakHtmlConverterPipe implements PipeTransform {
	transform( text: string, convertTo: 'LineBreak' | 'HTML' ): string {

		switch ( convertTo ) {
			case 'HTML':
				return text.replace( /\n/g, '<br/>' );

			case 'LineBreak':
				return text.replace( /'<br\/>'/g, '\n' );
		}
	}
}
